import { render } from "./OnboardingScreenFullWidth.vue?vue&type=template&id=b0b9d2ca&scoped=true"
import script from "./OnboardingScreenFullWidth.vue?vue&type=script&lang=js"
export * from "./OnboardingScreenFullWidth.vue?vue&type=script&lang=js"

import "./OnboardingScreenFullWidth.vue?vue&type=style&index=0&id=b0b9d2ca&lang=scss"
import "./OnboardingScreenFullWidth.vue?vue&type=style&index=1&id=b0b9d2ca&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0b9d2ca"]])

export default __exports__